var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerTaskNavIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 10 10",
    fill: "blue",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.16667H2.91667C3.60417 4.16667 4.16667 3.60417 4.16667 2.91667V2.5H7.08333C7.3125 2.5 7.5 2.6875 7.5 2.91667V5.83333H5.83333V8.75C5.83333 9.4375 6.39583 10 7.08333 10H8.75C9.4375 10 10 9.4375 10 8.75V5.83333H8.33333V2.91667C8.33333 2.22917 7.77083 1.66667 7.08333 1.66667H4.16667V0H0V2.91667C0 3.60417 0.5625 4.16667 1.25 4.16667ZM9.16667 8.75C9.16667 8.97917 8.97917 9.16667 8.75 9.16667H7.08333C6.85417 9.16667 6.66667 8.97917 6.66667 8.75V6.66667H9.16667V8.75ZM0.833333 0.833333H3.33333V2.91667C3.33333 3.14583 3.14583 3.33333 2.91667 3.33333H1.25C1.02083 3.33333 0.833333 3.14583 0.833333 2.91667V0.833333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTaskNavIcon1);
export default __webpack_public_path__ + "static/media/customerTaskNavIcon1.c41adab4ade6ed14661240e8c814df74.svg";
export { ForwardRef as ReactComponent };